import React, { useState, ReactNode } from 'react'
// Material
import { Box, IconButton, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { RoomTypes } from '@weblite/ts-action/room'
// Common
import { BackButton } from '$common/buttons'
// Icons
// TODO: REPLACE THIS MENU ICON IN USER-LIST-ITEMS
import { MenuIcon, SettingsIcon, EditOutlinedIcon } from '$common/icons'
// Component
import { ChatWithUserMenu } from '$comp/modals/menus/chat-with-user-menu/chat-with-user-menu'
import { WappProfileMenu } from '$comp/modals/menus/wapp-profile-menu'
import { HallProfileMenu } from '$comp/modals/menus/hall-profile-menu'
import { RoomProfileHeaderInfo } from './room-profile-header-info'

interface Props {
  onBack: () => any
  avatarElement: ReactNode
  avatarSrc: string
  primaryText: string
  secondaryText: string | number | JSX.Element
  onEdit?: () => any
  onSettings?: () => Promise<void>
  hasDeleted?: boolean
  avatarBackground?: string
  showMenuIcon?: boolean
  roomType: RoomTypes
  hallId?: string
  userId?: string
  backgroundColor: string
}

const StyledStack = styled(Stack)<{ backgroundColor?: string }>(
  ({ theme, backgroundColor }) => ({
    height: 129,
    minHeight: 129,
    backgroundColor: backgroundColor || theme.palette.neutral100,
    borderBottom: '1px solid',
    borderColor: theme.palette.neutral300,
    padding: '7px',
    boxSizing: 'border-box',
    color: backgroundColor
      ? theme.palette.neutral000
      : theme.palette.neutral900,
    position: 'relative',
  }),
)

const MENU_MAPPER: Record<RoomTypes, JSX.Element | null> = {
  GROUP: HallProfileMenu,
  CHANNEL: HallProfileMenu,
  PV: ChatWithUserMenu,
  WAPP_ROOM: WappProfileMenu,
  PRIVATE_SPACE: null,
}

export function RoomProfileHeader({
  onBack,
  avatarElement,
  avatarSrc,
  primaryText,
  secondaryText,
  onEdit,
  onSettings,
  showMenuIcon,
  roomType,
  hallId,
  userId,
  hasDeleted = false,
  avatarBackground = '',
  backgroundColor,
}: Props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [menuLocation, setMenuLocation] = useState({ xAxis: 0, yAxis: 0 })
  const onMenuClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setMenuLocation({ xAxis: e.clientX, yAxis: e.clientY })
    setIsMenuOpen(!isMenuOpen)
  }

  const Menu = MENU_MAPPER[roomType]
  return (
    <StyledStack backgroundColor={backgroundColor}>
      <Stack direction="row" justifyContent="space-between">
        <BackButton onClick={onBack} color="inherit" />
        <Box>
          {onSettings && (
            <IconButton sx={{ padding: 1 }} onClick={onSettings}>
              <SettingsIcon />
            </IconButton>
          )}
          {onEdit && (
            <IconButton sx={{ padding: 1 }} onClick={onEdit}>
              <EditOutlinedIcon />
            </IconButton>
          )}
          {!!showMenuIcon && (
            <>
              <IconButton sx={{ padding: 1 }} onClick={onMenuClick}>
                <MenuIcon fill="inherit" />
              </IconButton>
              {isMenuOpen && !!Menu && (
                <Menu
                  userId={userId}
                  hallId={hallId}
                  onClose={() => setIsMenuOpen(false)}
                  xAxis={menuLocation.xAxis}
                  yAxis={menuLocation.yAxis}
                />
              )}
            </>
          )}
        </Box>
      </Stack>
      <Box>
        <RoomProfileHeaderInfo
          avatarElement={avatarElement}
          avatarSrc={avatarSrc}
          primaryText={primaryText}
          secondaryText={secondaryText}
          hasDeleted={hasDeleted}
          avatarBackground={avatarBackground}
          backgroundColor={backgroundColor}
        />
      </Box>
    </StyledStack>
  )
}

RoomProfileHeader.defaultProps = {
  onMenu: null,
  onEdit: null,
  onSettings: null,
  hasDeleted: false,
  avatarBackground: '',
}
